import React, { useContext, useEffect } from 'react';
import { Drawer, Button, Col, Row, Typography } from 'antd';
import { ThemeContext } from '../Context/ThemeContext';
import { ProfileContext } from '../Context/ProfileContext';
import User from '../Card/UserCard';

const { Text } = Typography;

const ShowUsersDrawer = (props) => {
    const {
        users,
        setUsers,
        showUsers,
        getUsers,
        closeUsersDrawer,
        usersLoader,
    } = useContext(ProfileContext);
    const { theme } = useContext(ThemeContext);
    const loggedin = localStorage.getItem('loggedin') === 'true';

    useEffect(() => {
        // is loggedin?
        if (loggedin) {
            // has data in localstorage
            const localUsers = JSON.parse(localStorage.getItem('followers'));
            if (localUsers) {
                setUsers(localUsers);
            } else {
                // data unavailable fetch
                getUsers();
            }
        }
    }, []);

    return (
        <div>
            <Drawer
                title={
                    <Text style={{ color: theme.drawer.text }}>
                        You're Following
                    </Text>
                }
                width='100%'
                onClose={closeUsersDrawer}
                visible={showUsers}
                placement='right'
                headerStyle={{ background: theme.drawer.bg }}
                bodyStyle={{ background: theme.drawer.bg }}
                footerStyle={{ background: theme.drawer.bg }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button
                            onClick={closeUsersDrawer}
                            style={{ marginRight: 8 }}
                        >
                            Close
                        </Button>
                    </div>
                }
            >
                <Row>
                    <Col xs={0} sm={0} md={4} lg={6} />
                    <Col xs={24} sm={24} md={16} lg={12}>
                        {/* Show Following and Followers */}
                        {!usersLoader && users.length === 0 ? (
                            <Row justify='center' align='middle'>
                                <Col
                                    xs={24}
                                    sm={24}
                                    lg={12}
                                    style={{ textAlign: 'center' }}
                                >
                                    <Text
                                        type='secondary'
                                        style={{
                                            fontSize: '12px',
                                            color: theme.drawer.secondaryText,
                                        }}
                                    >
                                        You don't follow anyone.
                                    </Text>{' '}
                                    <br />
                                    <Text
                                        type='secondary'
                                        style={{
                                            fontSize: '12px',
                                            color: theme.drawer.secondaryText,
                                        }}
                                    >
                                        We are rolling out <code>Explore</code>{' '}
                                        section soon, stay updated
                                    </Text>
                                </Col>
                            </Row>
                        ) : (
                            <User loading={usersLoader} users={users} />
                        )}
                    </Col>
                    <Col xs={0} sm={0} md={4} lg={6} />
                </Row>
            </Drawer>
        </div>
    );
};

export default ShowUsersDrawer;
